import React, { Component } from 'react';
import AdminPrices from './adminPrices';
import AdminUsers from './adminUsers';
import AdminFilament from './adminFilament';

class Admin extends Component {
    state = {
    }
    render() {
        return (
            <div style={{ marginTop: '60px', marginBottom: '60px' }}>
                <AdminPrices />
                <AdminUsers />
            </div>
        );
    }
}

export default Admin;